import { memo } from "react";
import * as notificationCss from "./notification.module.css";
import { ActionRequiredBanner } from "./notifications/action-required-notification";
import { IncidentsBanner } from "./notifications/incident-banner";
import { UspsHazmatFeeBanner } from "./notifications/usps-hazmat-fee-banner";

/**
 * TODO: Refactor this to use a new notification system
 */
export const NotificationBanner = memo(function NotificationBanner() {
  return (
    <div className={notificationCss.updateBanner}>
      <UspsHazmatFeeBanner />
      <ActionRequiredBanner />
      <IncidentsBanner />
    </div>
  );
});
